import {
  CalculationInputs,
  CalculationResults,
} from "../../../types/calculatorTypes";

export class ContributionCalculator {
  private static readonly PAY_PERIODS_PER_YEAR = 26;
  /*   private static readonly MONTHS_PER_YEAR = 12;
  private static readonly PAYROLLS_PER_MONTH = 2; */

  public static calculate(inputs: CalculationInputs): CalculationResults {
    // Calculate per-payroll employee contribution
    /* const maxEmployeeContributionPerPayroll =
      inputs.maxAnnualContribution / this.PAY_PERIODS_PER_YEAR;
    const desiredEmployeeContributionPerPayroll =
      (inputs.annualSalary * inputs.employeeContributionRate) /
      100 /
      this.PAY_PERIODS_PER_YEAR;
   const employeeContributionPerPayroll = Math.min(
      desiredEmployeeContributionPerPayroll,
      maxEmployeeContributionPerPayroll
    ); */
    const employeeContributionPerPayroll =
      (inputs.annualSalary * inputs.employeeContributionRate) /
      100 /
      this.PAY_PERIODS_PER_YEAR;

    // Calculate employer match
    const maxMatchableSalaryPerPayroll =
      (inputs.annualSalary * inputs.maxEmployerMatchSalaryRate) /
      100 /
      this.PAY_PERIODS_PER_YEAR;
    const employerMatchPerPayroll = Math.min(
      employeeContributionPerPayroll * (inputs.employerMatchRate / 100),
      maxMatchableSalaryPerPayroll
    );

    const totalContributionPerPayroll =
      employeeContributionPerPayroll + employerMatchPerPayroll;

    // Calculate monthly growth rate
    /*     const monthlyGrowthRate =
      Math.pow(1 + inputs.annualGrowthRate / 100, 1 / 12) - 1; */

    // month-by-month wealth accumulation
    //let balance = 0;
    let totalEmployeeContributions = 0;
    let totalEmployerContributions = 0;

    totalEmployeeContributions =
      employeeContributionPerPayroll * this.PAY_PERIODS_PER_YEAR;
    totalEmployerContributions =
      employerMatchPerPayroll * this.PAY_PERIODS_PER_YEAR;

    const totalContributions =
      totalEmployeeContributions + totalEmployerContributions;
    const investmentGrowth =
      totalContributions * (inputs.annualGrowthRate / 100) * 0.5;
    const balance = totalContributions + investmentGrowth;

    return {
      employeeContributionPerPayroll: Math.round(
        employeeContributionPerPayroll
      ),
      employerMatchPerPayroll: Math.round(employerMatchPerPayroll),
      totalContributionPerPayroll: Math.round(totalContributionPerPayroll),
      totalEmployeeContributions: Math.round(totalEmployeeContributions),
      totalEmployerContributions: Math.round(totalEmployerContributions),
      investmentGrowth: Math.round(investmentGrowth),
      totalWealthAfter12Months: Math.round(balance),
    };
  }
}
